"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMap = void 0;
var _isObject = require("./isObject");
var deepMap = function deepMap(obj, callBack) {
  var out = {};
  Object.keys(obj).forEach(function (key) {
    var val;
    if ((0, _isObject.isObject)(obj[key])) {
      val = deepMap(obj[key], callBack);
    } else {
      val = callBack(obj[key], key);
    }
    out[key] = val;
  });
  return out;
};
exports.deepMap = deepMap;